// extracted by mini-css-extract-plugin
export default {"button-switch__button":"styles_button-switch__button__H4Z9G","button-switch__button--not-selected":"styles_button-switch__button--not-selected__EvFPE"};